import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

// routes config
import routes from '../../core/navigation/routes';
import { routePaths } from './../../core/navigation/route-paths';
import NewsDetailV2Container from '../../views/news-v2/news-detail/newDetail-v2.container';
import DocumentContainer from '../../views/documents/document.container';

const loading = (
  <div className={'container-loading'}>
    <div className={'loader'} />
  </div>
);

const Content: React.FC = () => {
  return (
    <main className={''}>
      <Suspense fallback={loading}>
        <Switch>
          {routes.map((route, idx) => {
            return (
              route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  render={(props) => <route.component {...props} />}
                />
              )
            );
          })}
          <Route path={`${routePaths.News}/:id`}>
            <NewsDetailV2Container />
          </Route>
          <Route
            key={'/public/assets'}
            path={'/public/assets/documents/:name'}
            render={(props) => <DocumentContainer {...props} />}
          />
        </Switch>
      </Suspense>
    </main>
  );
};

export default React.memo(Content);
